var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaronis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    fill: "#010203"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14277 7.18555H6L11.6698 15.5044L12.7383 13.9277L8.14277 7.18555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2042 14.6133L12.1357 16.1881L12.284 16.4057C12.3435 16.5079 12.4244 16.596 12.5211 16.664C12.6178 16.732 12.7281 16.7783 12.8444 16.7997C12.9607 16.8211 13.0803 16.8171 13.1949 16.788C13.3095 16.7588 13.4164 16.7053 13.5084 16.6309C13.6105 16.5716 13.6985 16.4911 13.7667 16.3948C13.8349 16.2985 13.8817 16.1887 13.9037 16.0728C13.9258 15.9569 13.9227 15.8376 13.8947 15.723C13.8667 15.6083 13.8144 15.5011 13.7414 15.4084L13.2042 14.6133Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2435 7.18555H10.1007L13.7144 12.4895L14.7848 10.9128L12.2435 7.18555Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.846 15.4057L15.2412 11.5957L14.1727 13.1706L16.3848 16.403C16.517 16.5968 16.7209 16.7301 16.9514 16.7736C17.1819 16.8171 17.4203 16.7672 17.614 16.635C17.8078 16.5027 17.9411 16.2989 17.9846 16.0684C18.0281 15.8379 17.9783 15.5995 17.846 15.4057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaronis);
export default __webpack_public_path__ + "static/media/Varonis.a8f11694bc6973662f1a33f67bf30a76.svg";
export { ForwardRef as ReactComponent };